// src/fcm.js

import { getMessaging, getToken } from "firebase/messaging";
import { db } from './firebase';
import { doc, setDoc } from "firebase/firestore";

// -------- ⚠️ ATTENZIONE: INCOLLA QUI LA TUA CHIAVE VAPID --------
// La chiave che hai generato nella console di Firebase -> Project Settings -> Cloud Messaging
const VAPID_KEY = "BFWg6a1yfi3QtHVYvRISzCrPmpZ8hHxtdErKkYVMPG1ekKblA8EJ1fyYYrWITeFCaVONg7tuhOoq8pNcRZwtcYI";
// --------------------------------------------------------------------

export const requestNotificationPermission = async (user) => {
  if (!user || !('Notification' in window)) {
    console.log("Questo browser non supporta le notifiche desktop.");
    return;
  }
  
  if (Notification.permission === 'granted') {
    await saveMessagingDeviceToken(user);
    return;
  }

  if (Notification.permission === 'denied') {
    return;
  }

  const permission = await Notification.requestPermission();

  if (permission === 'granted') {
    await saveMessagingDeviceToken(user);
  }
};


// Funzione per ottenere il token e salvarlo su Firestore
const saveMessagingDeviceToken = async (user) => {
  try {
    const messaging = getMessaging();
    const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
    
    if (currentToken) {
      console.log('Token FCM ottenuto:', currentToken);
      
      // --- MODIFICA CHIAVE ---
      // Salviamo il token nel documento 'userLookup' (che esiste sempre)
      // invece che nel documento 'staff' (che può non esistere per un Super Admin)
      const { uid } = user; 

      if (!uid) {
          console.error("Errore salvataggio FCM Token: UID utente non trovato.");
          return;
      }

      // Usiamo setDoc con merge:true per creare o aggiornare il campo
      const userLookupRef = doc(db, 'userLookup', uid);
      await setDoc(userLookupRef, {
        fcmToken: currentToken, // Aggiunge/Aggiorna questo campo
      }, { merge: true }); // 'merge: true' assicura che non sovrascriviamo altri campi
      // --- FINE MODIFICA ---

      console.log('Token salvato nel profilo userLookup.');

    } else {
      console.log('Nessun token di registrazione disponibile. Richiedi il permesso per le notifiche.');
    }
  } catch (err) {
    // Questo errore ora non dovrebbe più accadere
    console.error('Errore durante il recupero o salvataggio del token:', err);
  }
};